import { Component, Optional, Inject } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { UntypedFormBuilder } from '@angular/forms';
import { first } from 'rxjs/operators';
import { CommonAamvaModel } from '../models/common-aamva.model';
import { CommonAamvaIncidentService } from '../services/common-aamva-incident.service';
import { IncidentTypeService } from '../services/incident-type.service';
import { IncidentDialogContext } from '../shared/incident-dialog-context.model';
import { IncidentModalComponent } from '../incident-modal.component';
import { IncidentService } from '../services/incident.service';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ProhibitionService } from '../../prohibition/services/prohibition.service';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { Jurisdiction } from 'app/foundation/models/enums/jurisdiction.enum';
import { CustomerLookupService } from 'app/customer/customer-lookups.service';
import { EnumDataService } from '../services/enums.DataService';

@Component({
    templateUrl: './common-incident-modal-aamva.html'
})

export class CommonAamvaModalComponent extends IncidentModalComponent<CommonAamvaModel> {

    private lookUpService: CustomerLookupService;
    public jurisdictions: any;

    constructor(
        lookUpService: CustomerLookupService,
        public dialogRef: MatDialogRef<IncidentModalComponent<CommonAamvaModel>>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: IncidentDialogContext<CommonAamvaModel>,
        private service: CommonAamvaIncidentService,
        location: PlatformLocation,
        fb: UntypedFormBuilder,
        typeService: IncidentTypeService,
        prohibitionService: ProhibitionService,
        modalService: MvdModalService,
        incidentService: IncidentService,
        EnumDataService: EnumDataService
    ) {
        super(data, prohibitionService, fb, dialogRef, modalService, incidentService, EnumDataService, typeService, location);
        this.service = service;
        this.lookUpService = lookUpService;
        this.hasCdlCheckboxOnForm = true;
        lookUpService.getData('individual').pipe(first())
            .subscribe(
                r => this.jurisdictions = r.result.jurisdictions,
                e => {
                    console.log('error', e);
                });
    }

    protected onLoadIncident(callback: (error?) => void): void {
        this.service.getIncident(this.data.incident.incidentNumberId).subscribe(r => this.onGetIncidentCompleted(r, callback), e => callback(e));
    }

    private onGetIncidentCompleted(incident: CommonAamvaModel, callback: (error?) => void): void {
        this.data.incident = incident;

        this.showUserInput = true;

        setTimeout(() => {
            this.incidentForm.get('isCDLHolder').setValue(this.data.incident.cdlHolderIndicator);
            this.incidentForm.get('driverLicenseNumber').setValue(this.data.incident.driverLicenseNumber);
            this.incidentForm.get('driverLicenseJurisdiction').setValue(this.data.incident.driverLicenseJurisdictionId);
        }, 350);

        callback();
    }

    protected onSaveIncident(callback: (error?: any) => void): void {

        this.data.incident.cdlHolderIndicator = this.incidentForm.get('isCDLHolder').value;
        this.data.incident.driverLicenseNumber = this.incidentForm.get('driverLicenseNumber').value;
        this.data.incident.driverLicenseJurisdictionId = this.incidentForm.get('driverLicenseJurisdiction').value;

        if (this.data.incident.cdlHolderIndicator == null) {
            this.data.incident.cdlHolderIndicator = false;
        }

        this.service.saveIncident(this.data.incident).subscribe(r => { }, callback, callback);
    }

    protected onDeleteIncident(callback: () => void): void {
        this.service.deleteIncident(this.data.incident.incidentNumberId).subscribe(result => { }, e => this.handleError, () => {
            this.dialogRef.close(true);
        });
    }
}
